var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer mainFooter"},[_c('div',[_vm._v("contact : elearning.ordpmk@pcm.ac.th")]),_vm._v(" E-learning CopyRight © 2021 ")])
}]

export { render, staticRenderFns }